import React from "react";
import { formatShowTime } from "../../../utils/util";

interface TitleProps {
    userName: string;
    sendTime: number;
    isShowName?: boolean;
}

export const TitleCom: React.FC<TitleProps> = ({ sendTime = 0, userName, isShowName }) => {
    return (
        <div className="title-com">
            {isShowName && <div className="title">{userName}</div>}
            <div className="send-time">{formatShowTime(sendTime)}</div>
        </div>
    );
};
